import CallToAction from 'components/contentBlocks/CallToAction';
import PropTypes from 'prop-types';
import React from 'react';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import { mediaQueries } from 'config/theme/breakpoints';
import ratios from 'config/theme/ratios';
import transformButtons from 'libs/wordpress/utils/transformButtons';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

// Pure CMS data transformation before we send it to the "real" block!
const CallToActionBasicBlock = ({ content = {}, isColumn = false, moduleTextColor = '' }) => {
    const { background_media_flexible: backgroundFlexible, buttons, heading, tag } = content;

    // Transform background data
    const isAboveSm = useAboveBreakpoint('sm');
    const transformedBackground = transformFlexibleBackground(backgroundFlexible);
    const mobileBackground = transformedBackground.mobile;
    const desktopBackground = transformedBackground.desktop;

    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;
    const buttonTheme = ligthTheme ? 'outlinedWhite' : 'outlinedBlack';

    return (
        <CallToAction
            basic
            background={isAboveSm ? desktopBackground : mobileBackground}
            backgroundRatio={isColumn ? ratios.horizontal : [ratios.vertical, ratios.square, ratios.horizontal]}
            backgroundType={isAboveSm ? desktopBackground.type : mobileBackground.type}
            buttons={buttons ? transformButtons(buttons, { theme: buttonTheme }) : null}
            heading={heading ? decodeHTMLEntities(heading.text) : null}
            headingSize="lg"
            headingTag={heading ? heading.type : null}
            isColumn={isColumn}
            mediaQuery={mediaQueries.fullWidth}
            tag={decodeHTMLEntities(tag)}
            textColor={textColor}
        />
    );
};

CallToActionBasicBlock.propTypes = {
    content: PropTypes.shape({
        'background_media_flexible': PropTypes.exact({
            mobile: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
            desktop: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
        }).isRequired,
        button: PropTypes.object,
        heading: PropTypes.object,
        tag: PropTypes.string,
        paragraph: wysiwygProp,
    }),
    isColumn: PropTypes.bool,
    moduleTextColor: PropTypes.string,
};

export default CallToActionBasicBlock;
